
export class Vendor {
    constructor(
        public id: number = null,
        public minNumberOfEmployees: number = null,
        public maxNumberOfEmployees: number = null,
        public yearEstablished: number = null,
        public addresses: Array<any> = [],
        public categories: Array<any> = [],
        public logo: string = '',
        public name: string = '',
        public warrantyTerms: string = '',
        public returnPolicy: string = '',
        public paymentMethods: Array<any> = [],
        public phones: Array<any> = [],
        public photos: Array<any> = [],
        public products: Array<string> = [],
        public serviceAreas: Array<string> = [],
        public userCompany: any = null,
        public userCorporations: Array<any> = [],
        public bonded: boolean = false,
        public workersCompensation: boolean = false,
        public liabilityInsurance: boolean = false,
        public writtenContract: boolean = false,
        public verified: boolean = false,
        public membership: string = '',
        public licences: string = '',
        public services: string = '',
        public companies: Array<any> = [],
        public corporations: Array<any> = [],
        public corporationsAndLists: Array<any> = [],
        public primaryPhone: string = '',
        public primaryCity: string = '',
        public sponsoredFrom: string = '',
        public sponsoredTo: string = '',
        public checked: boolean = false,
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public formFields = {
            services: {editMode: false},
            corporations: {editMode: false},
            categories: {editMode: false},
            products: {editMode: false},
            yearEstablished: {editMode: false},
            numberOfEmployees: {editMode: false},
            returnPolicy: {editMode: false},
            paymentMethods: {editMode: false},
            licences: {editMode: false},
            membership: {editMode: false},
            liabilityInsurance: {editMode: false},
            workersCompensation: {editMode: false},
            bonded: {editMode: false},
            writtenContract: {editMode: false},
            warrantyTerms: {editMode: false},
        }
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Vendor.ts